module.exports = __webpack_public_path__ + "static/media/sad.e0af5c11.png";